import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ResultSelectContext from "../../../providers/ResultSelectContext";

export default function Download() {
  const { t } = useTranslation();
  const { downloadSelectedCSV, selectedResultIds, downloadCatalog } =
    useContext(ResultSelectContext);

  const selectedResultIdsArr = Reflect.ownKeys(selectedResultIds).filter(
    (key) => selectedResultIds[key],
  );
  return (
    <div className="c-button__list c-button__list--center-s">
      <button
        type="button"
        disabled={!selectedResultIdsArr.length}
        onClick={downloadCatalog}
        className="c-button c-button--s c-button--download"
      >
        {t("Download the catalog")}
      </button>
      <button
        className="c-button c-button--s c-button--download"
        onClick={downloadSelectedCSV}
        disabled={!selectedResultIdsArr.length}
      >
        {t("Download search results in CSV format")}
      </button>
    </div>
  );
}
